module.exports = __webpack_public_path__ + "img/捷豹.png";